module.exports = __webpack_public_path__ + "img/3.3241d8f6.svg";